window['Gateway'] ??= {};
const Gateway = window['Gateway'];
Gateway.UI = Gateway.UI || {};

Gateway.UI.Polls = {
    getValidationReport: function (pollId, onSuccess, onError) {
        window.Browser.send(
            '/ui/polls/' + pollId + '/validationReport',
            null,
            onSuccess,
            onError
        );
    }

};
